"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var strings_1 = require("./strings");
exports.MEMO_ACTIONS = [
    strings_1.ACTIONED,
    strings_1.COMMENTED,
    strings_1.CREATED,
    strings_1.FILE_SAVED,
    strings_1.HEARTED,
    strings_1.HIDDEN,
    strings_1.SHARED,
    strings_1.UNSHARED,
    strings_1.VIEWED,
    strings_1.PUBLIC_SHARED,
    strings_1.PUBLIC_UNSHARED,
    strings_1.PUBLIC_VIEWED,
];
